import React, { ReactNode } from 'react';
import { BenefitAddOn } from './components/BenefitAddOn';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { WELLNESS_ADD_ON_DETAILS } from '../../../../data/wellness-add-ons';
import { Typography } from '../../../../wag-react/components/Typography';
export type WellnessAddOnsSectionProps = {
  onHelpIconClick: (name: string, description: ReactNode) => void;
};
export const WellnessAddOnsSection = ({
  onHelpIconClick
}: WellnessAddOnsSectionProps) => <Container mt={5} data-sentry-element="Container" data-sentry-component="WellnessAddOnsSection" data-sentry-source-file="index.tsx">
    <SectionHeading fontSize={['24px', null, '30px']} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
      Optional add-ons
    </SectionHeading>

    <Typography textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {'Add up to four additional benefits to each pet\'s wellness plan'}
    </Typography>

    {WELLNESS_ADD_ON_DETAILS.map(({
    description,
    name,
    price
  }) => <BenefitAddOn key={name} description={description} name={name} onHelpIconClick={onHelpIconClick} price={price} mb="8px" />)}
  </Container>;